import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 16,
    marginBottom: 22,
  },
  title: {
    fontSize: 16.6,
    lineHeight: 22.1,
    letterSpacing: 0,
  },
  tab: theme => ({
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
    backgroundColor: theme.colors.borderColorSix,
    flex: 1,
    alignItems: 'center',
    paddingVertical: 12,
  }),
  middle: {
    borderRadius: 0,
  },
  last: {
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  active: theme => ({
    backgroundColor: theme.colors.activeColor,
  }),
});
